import React from "react";
import { useGame } from "@/context/GameContext";

const CONFETTI_COLORS = [
  "#F59E0B",
  "#3B82F6",
  "#EC4899",
  "#10B981",
  "#A855F7",
  "#EF4444",
];

const EffectsLayer = () => {
  const { floatingCoins, confettiOn } = useGame();

  return (
    <>
      {/* Floating +$ coins */}
      <div className="pointer-events-none fixed bottom-24 left-1/2 -translate-x-1/2 z-50 flex flex-col items-center">
        {floatingCoins.map((c) => (
          <div
            key={c.id}
            className={`animate-coin-float font-display font-black text-3xl drop-shadow-lg ${c.amount < 0 ? "text-rose-500" : "text-amber-500"}`}
            data-testid="floating-coin"
          >
            {c.amount < 0 ? `-$${Math.abs(c.amount)}` : `+$${c.amount}`}
          </div>
        ))}
      </div>

      {/* Confetti */}
      {confettiOn && (
        <div className="pointer-events-none">
          {Array.from({ length: 60 }).map((_, i) => (
            <div
              key={`confetti-${i}`}
              className="confetti-bit"
              style={{
                left: `${Math.random() * 100}%`,
                backgroundColor:
                  CONFETTI_COLORS[i % CONFETTI_COLORS.length],
                animationDelay: `${Math.random() * 0.6}s`,
                animationDuration: `${2 + Math.random() * 1.5}s`,
              }}
            />
          ))}
        </div>
      )}
    </>
  );
};

export default EffectsLayer;
